// src/layouts/SiteLayout.jsx
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import AnimatedBackground from "../components/AnimatedBackground";

export default function SiteLayout({ children }) {
  return (
    <div className="relative min-h-screen flex flex-col text-slate-900">
      {/* Global animated background behind everything */}
      <AnimatedBackground className="fixed inset-0 -z-10 pointer-events-none" />

      {/* Header stays at the top */}
      <Navbar />

      {/* This grows to fill leftover space so the footer sits at the bottom */}
      <main className="flex-1 relative z-10">
        {children}
      </main>

      {/* Footer naturally sticks to bottom when content is short */}
      <Footer />
    </div>
  );
}
